module.exports = __webpack_public_path__ + "img/moottorirata_original.29bde572.jpg";